import React from 'react';
import { CollectionPropertyValue } from '../RealtimeCollectionProvider';
import CollectionPropertyTextSelect from './CollectionPropertyTextSelect';
import CollectionPropertySelect from './CollectionPropertySelect';
import { CollectionProperty } from '@saga/shared';
import CollectionPropertyCheckboxSelect from './CollectionPropertyCheckboxSelect';
import CollectionPropertyDateSelect from './CollectionPropertyDateSelect';
import CollectionPropertyURLSelect from './CollectionPropertyURLSelect';

function CollectionItemPropertySelect({
    property,
    onChangeValue,
    onChangeProperty,
    disabled = false,
    showEmptyState = false,
}: {
    property: CollectionPropertyValue;
    onChangeValue: (value: string | undefined) => void;
    onChangeProperty: (property: Partial<Omit<CollectionProperty, 'id' | 'values'>>) => void;
    disabled?: boolean;
    showEmptyState?: boolean;
}) {
    if (property.type === 'multiSelect' || property.type === 'singleSelect') {
        return (
            <CollectionPropertySelect
                property={property}
                onChangeValue={onChangeValue}
                onChangeProperty={onChangeProperty}
                showEmptyState={showEmptyState}
                multiple={property.type === 'multiSelect'}
                disabled={disabled}
            />
        );
    }
    if (property.type === 'url') {
        return (
            <CollectionPropertyURLSelect
                property={property}
                onChangeValue={onChangeValue}
                showEmptyState={showEmptyState}
                disabled={disabled}
            />
        );
    }
    if (property.type === 'string' || property.type === 'number') {
        return (
            <CollectionPropertyTextSelect
                property={property}
                onChangeValue={onChangeValue}
                showEmptyState={showEmptyState}
            />
        );
    }
    if (property.type === 'checkbox') {
        return (
            <CollectionPropertyCheckboxSelect property={property} onChangeValue={onChangeValue} disabled={disabled} />
        );
    }
    if (property.type === 'date') {
        return (
            <CollectionPropertyDateSelect
                property={property}
                onChangeValue={onChangeValue}
                showEmptyState={showEmptyState}
                disabled={disabled}
            />
        );
    }
    return null;
}

export default CollectionItemPropertySelect;
